import { TPricingPlans } from '../../types';
import { PricingCardStaticDetailsTypesV1 } from './card-details-constants-v1';
import {
  customWhenRequiredMap,
  customServicesIncludedMap,
  customNameMap,
  customShortDescriptionMap,
  customBuyLinkMap,
  customKnowLinkMap,
} from './custom-when-required';
import { PricingCardV1 } from './pricing-card-v1.component';

export const PricingCardWrapperV1 = ({
  PricingCardStaticDetails,
  pricingPlanData,
  classname = '',
}: {
  PricingCardStaticDetails: PricingCardStaticDetailsTypesV1[];
  pricingPlanData: TPricingPlans[];
  classname: string;
}) => {
  return (
    <div id="Recommended-plan" className={classname}>
      <div className="grid grid-cols-4 gap-3 xl:gap-6 lg:grid-cols-4 items-stretch sm:grid sm:grid-cols-1 flex-wrap md:grid md:grid-cols-2 md:gap-4 mt-11 sm:mt-8">
        {pricingPlanData?.map((planData, index) => {
          const externalId = planData.externalId;
          const updatedPlanData = {
            ...planData,
            planDetails: {
              ...planData.planDetails,
              name: customNameMap[externalId] || planData.planDetails.name,
              shortDescription:
                customShortDescriptionMap[externalId] ||
                planData.planDetails.shortDescription,
              buyLink: customBuyLinkMap[externalId]
                ? customBuyLinkMap[externalId]
                : planData.planDetails.buyLink,
              knowLink: customKnowLinkMap[externalId]
                ? customKnowLinkMap[externalId]
                : planData.planDetails.knowLink,
              whenRequired:
                customWhenRequiredMap[externalId] ||
                planData.planDetails.whenRequired,
              servicesIncluded:
                customServicesIncludedMap[externalId] ||
                planData.planDetails.servicesIncluded,
            },
          };

          return (
            <PricingCardV1
              key={externalId}
              card={PricingCardStaticDetails[index]}
              pricingPlanData={updatedPlanData}
            />
          );
        })}
      </div>
    </div>
  );
};
